
      import { Buffer } from "buffer/"; // <-- no typo here ("/")
      window.Buffer = Buffer;
    